import { useParams } from "react-router-dom";
import ManageRoles from "../../Components/Management/ManageRoles/ManageRoles";
import ManageSponsors from "../../Components/Management/ManageSponsors/ManageSponsors";
import ManageUser from "../../Components/Management/ManageUsers/ManageUsers";
import ManageContact from "../../Components/Management/ManageContacts/ManageContact";
import ManageStudy from "../../Components/Management/ManageStudy/ManageStudy";
import ActiveIngredient from "../../Components/Management/ManageActiveIngredients/ManageActiveIngredient";
import ManageProduct from "../../Components/Management/ManageProduct/ManageProdut";

function UserManagement() {
  const { type } = useParams();
  return (
    <div className="subContainer">
      {type === "sponsors" && <ManageSponsors />}
      {type === "roles" && <ManageRoles />}
      {type === "users" && <ManageUser />}
      {type === "contact-library" && <ManageContact />}
      {type === "study-library" && <ManageStudy />}
      {type === "active-ingredients" && <ActiveIngredient />}
      {type === "products" && <ManageProduct />}
    </div>
  );
}

export default UserManagement;
